import { ISO_CODE_GERMANY, ISO_CODE_NETHERLANDS } from '@constants/countries';
import { getAssetsFolder } from '@utilities/get-assets-folder';

const TEST_GERMANY = false;
const LANGUAGE_ISO_CODE = TEST_GERMANY ? ISO_CODE_GERMANY : ISO_CODE_NETHERLANDS;
const LOCAL_DICTIONARY_PATH = TEST_GERMANY ? '/lang/de.json' : '/lang/nl.json';

const defaultProps = {
    environment: 'local',
    baseApi: 'https://hoefenhaag.acc.bpd.nl',
    dictionaryUrl: getAssetsFolder(LOCAL_DICTIONARY_PATH),
    languageIsoCode: LANGUAGE_ISO_CODE,
    apiBaseUrl: 'https://hoefenhaag.acc.bpd.nl/api/middleware',
    compareUrl: '/compare-houses',
    areaHouseOverviewUrl: '/properties-overview',
    logoutUrl: 'https://bpd--acceptance.sandbox.my.site.com/myhome/secur/logout.jsp',
    areaProjectName: 'Hoefenhaag U13',
    mapbox: {
        style: 'bpd-acc/ciowo3k3f000udum18y8x7qd0',
        accessToken:
            'pk.eyJ1IjoiYnBkLWFjYyIsImEiOiJjaWlzbzBreXcwMzk5dTZrbnNlMDY1ZTFhIn0.N4JONLqHs9Bc67kJTikkXw',
    },
};

const prodDefaultProps = {
    ...defaultProps,
    baseApi: 'https://corpweb.bpd.nl',
    apiBaseUrl: 'https://bpd-api-web-prod.azurewebsites.net/',
    logoutUrl: 'https://www.mijneigenhuis.nl/secur/logout.jsp',
    mapbox: {
        style: 'bpd/cj47zzkvg1jo62roansv1k0mo',
        accessToken:
            'pk.eyJ1IjoiYnBkIiwiYSI6IjBiNTQyNmIyNTFmNTk4NDdkOTE1MDMyNDViYWRmMDI1In0.tfd0_36gpomlERjFuqPIsQ',
    },
};

const hoefenhaag = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        nodeId: '142857',
        areaId: 'a0iw0000008QvIVAA0',
        districtId: 'a0lw000000EBLa4AAH',
        houseSelectorId: '243582',
        districtHouseOverviewUrl: {
            a0lw000000EBLa4AAH: '/het-dorpshart/woningen',
            a0lw000000EBvWTAA1: '/het-lint/woningen',
            a0lw000000EBvWYAA1: '/de-erven/woningen',
        },
    };
};

const digitalpark = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        environment: 'acceptance',
        nodeId: '235783',
        areaId: 'a0i7R00001qWMD9QAO',
        areaProjectName: 'Digital park',
        districtId: 'a0l7R00000dUs1zQAC',
        hasWishlist: true,
        districtHouseOverviewUrl: {
            a0l7R00000dUs1zQAC: '/department-digitals/woningen',
            a0l7R00000gK6fuQAC: '/department-digital-rental/woningen',
        },
        compareUrl: '/vergelijken',
        areaHouseOverviewUrl: '/woningen',
    };
};

const world = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        baseApi: 'https://world.u8projects.bpdacp.nl',
        nodeId: '147199',
        areaId: 'a0i2X00000PBIIMQA5',
        districtId: 'a0l7R00000cpbjYQAQ',
        districtHouseOverviewUrl: {
            a0l2X00000ccf5BQAQ: '/de-veluwse-proeftuin/woningen',
            a0l7R00000cpbjYQAQ: '/de-gelderse-stadstuin/woningen',
        },
    };
};

const vathorstWaterdorp = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        nodeId: '202474',
        areaId: 'a0iw000000ADq8xAAD',
        districtId: 'a0lw000000OnMQjAAN',
        districtHouseOverviewUrl: {
            a0l2X00000YarM6QAJ: '/laakse-tuinen/woningen',
            a0lw000000OnMQjAAN: '/waterdorp/woningen',
            a0lw000000OnMQeAAN: '/de-bron/woningen',
        },
    };
};

const hetDorpshart = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        nodeId: '142857',
        areaId: 'a0iw0000008QvIVAA0',
        districtId: 'a0lw000000EBLa4AAH',
        houseSelectorId: '240865',
        districtHouseOverviewUrl: {
            a0lw000000EBLa4AAH: '/het-dorpshart/woningen',
            a0lw000000EBvWTAA1: '/het-lint/woningen',
            a0lw000000EBvWYAA1: '/de-erven/woningen',
        },
    };
};

const deErven = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        nodeId: '143176',
        areaId: 'a0iw0000008QvIVAA0',
        districtId: 'a0lw000000EBvWYAA1',
        houseSelectorId: '293564',
        hasWishlist: true,
        districtHouseOverviewUrl: {
            a0lw000000EBLa4AAH: '/het-dorpshart/woningen',
            a0lw000000EBvWTAA1: '/het-lint/woningen',
            a0lw000000EBvWYAA1: '/de-erven/woningen',
        },
    };
};

const foodCenter = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        baseApi: 'http://foodcenter.u8projects.bpdacp.nl',
        nodeId: '147199',
        areaId: 'a0i2X00000PBIIMQA5',
        districtId: 'a0l7R00000cpbjYQAQ',
        houseSelectorId: '241208',
        districtHouseOverviewUrl: {
            a0l2X00000ccf5BQAQ: '/de-veluwse-proeftuin/woningen',
            a0l7R00000cpbjYQAQ: '/de-gelderse-stadstuin/woningen',
        },
    };
};

const hoefenhaagProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        nodeId: '142664',
        areaId: 'a0iw0000008QvIVAA0',
        districtHouseOverviewUrl: {
            a0lw000000EBLa4AAH: '/het-dorpshart/woningen',
            a0lw000000EBvWTAA1: '/het-lint/woningen',
            a0lw000000EBvWYAA1: '/de-erven/woningen',
        },
    };
};

const ringersProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        baseApi: 'https://www.nieuwbouw-ringersProd.nl',
        nodeId: '68337',
        areaId: 'a0iw000000BPSpuAAH',
        districtId: 'a0lw000000U80ocAAB',
        districtHouseOverviewUrl: {
            a0lw000000U80ocAAB: '/woningen',
        },
    };
};

const kvlProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        nodeId: '71315',
        baseApi: 'https://nieuwbouw-kvl.nl',
        areaId: 'a0iw0000009AOvlAAG',
        districtHouseOverviewUrl: {
            a0lw000000MoKjfAAF: '/kvl-dorp/woningen',
            a0lw000000MoKn8AAF: '/kvl-centraal/woningen',
            a0lw000000MoB85AAF: '/kvl-west/woningen',
        },
    };
};

const odeProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        nodeId: '155929',
        baseApi: 'https://nieuwbouw-ode.nl',
        areaId: 'a0iw000000900CZAAY',
        districtId: 'a0l2X00000b0ISYQA2',
        districtHouseOverviewUrl: {
            a0l2X00000b0ISYQA2: '/woningen',
        },
    };
};

const denieuwedefensie = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...defaultProps,
        nodeId: '131968',
        baseApi: 'https://www.nieuwbouw-denieuwedefensie.acc.bpd.nl',
        areaId: 'a0i2X00000Cf6aQQAR',
        districtId: 'a0l2X00000YRioKQAT',
        districtHouseOverviewUrl: {
            a0lw000000OoFxCAAV: '/woningen',
        },
    };
};

const denieuwedefensieProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        nodeId: '131968',
        baseApi: 'https://www.nieuwbouw-denieuwedefensie.nl',
        areaId: 'a0i2X00000Cf6aQQAR',
        districtId: 'a0l2X00000YRioKQAT',
        districtHouseOverviewUrl: {
            a0lw000000OoFxCAAV: '/woningen',
        },
    };
};

const veryGoodHouseSelectorProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        nodeId: '208349',
        baseApi: 'https://www.nieuwbouw-oegstgeestaanderijn.nl',
        areaId: 'a0iw0000009NHiTAAW',
        districtId: 'a0l7R00000coPuuQAE',
        houseSelectorId: '240867',
        districtHouseOverviewUrl: {
            a0l7R00000coPuuQAE: '/rhijnhoeve/woningen',
            a0l2X00000dOvO8QAK: '/eiland-van-oegstgeest/woningen',
            a0l2X00000WSbecQAD: '/buitenplaats-rijnweijde/woningen',
            a0lw000000NCfe0AAD: '/parksingel/woningen',
            a0lw000000U9VfHAAV: '/kop-van-rhijn/woningen',
            a0lw000000NCfdqAAD: '/nieuw-rhijnzicht/woningen',
        },
    };
};

const oudijmuidenProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        nodeId: '68108',
        baseApi: 'https://www.oudijmuiden.nl/',
        areaId: 'a0iw000000AEmvjAAD',
        districtId: 'a0lw000000OoRT8AAN',
        districtHouseOverviewUrl: {
            a0lw000000OoRT8AAN: '/woningen',
        },
    };
};

const kazerneTerreinenProd = () => {
    window.__ENVIRONMENT_DETAILS__ = {
        ...prodDefaultProps,
        baseApi: 'https://www.nieuwbouw-kazerneterreinen.nl',
        nodeId: '26241',
        areaId: 'a0iw0000009MxQ7AAK',
        houseSelectorId: '270797',
        hasWishlist: true,
        districtHouseOverviewUrl: {
            a0l7R00000cptgqQAA: '/helden-van-de-heide/woningen',
            a0lw000000NCONZAA5: '/sysseltse-lanen/woningen',
        },
    };
};

const mockData = {
    hoefenhaag,
    digitalpark,
    hetDorpshart,
    deErven,
    foodCenter,
    world,
    vathorstWaterdorp,
    hoefenhaagProd,
    kvlProd,
    odeProd,
    denieuwedefensie,
    denieuwedefensieProd,
    veryGoodHouseSelectorProd,
    oudijmuidenProd,
    ringersProd,
    kazerneTerreinenProd,
};

export default mockData;
